module.exports = __webpack_public_path__ + "static/assets/94408e5d1e8cc2692140d3e691ddff88.png";